
export const  REFER_A_FRIEND_LOAD_START = "Refer_A_Friend_Load_Start";
export const  REFER_A_FRIEND_LOAD_END = "Refer_A_Friend_Load_End";
export const  REFER_A_FRIEND_COPY_COUPON_CODE = "Refer_A_Friend_Copy_Coupon_Code";
export const  REFER_A_FRIEND_SHARE_CLICK = "Refer_A_Friend_Share_Click";
export const  REFER_A_FRIEND_SHARE_OPTION_CLICK = "Refer_A_Friend_Share_Option_Click";
export const  REFER_A_FRIEND_INPUT_CLICK ="Refer_A_Friend_Input_Click";
export const  REFER_A_FRIEND_BUTTON_CLICK = "Refer_A_Friend_Button_Click"; 
export const  REFER_A_FRIEND_COUNTRY_CODE_SELECT = "Refer_A_Friend_Country_Code_Select"